"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceEligibilityType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var InsuranceEligibilityType_Factory = /** @class */ (function () {
    function InsuranceEligibilityType_Factory() {
    }
    InsuranceEligibilityType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    InsuranceEligibilityType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return InsuranceEligibilityType_Factory;
}());
exports.InsuranceEligibilityType_Factory = InsuranceEligibilityType_Factory;
